<script lang="ts" setup>
import { ref, watch } from 'vue';
import { NewMessage, Done } from '@xpos/icons-svg';
import SchemaForm from '@xpos/ui/src/components/SchemaForm/index.vue';
import passwordFormSchema from '@/forms/password.json';
import { useI18n } from 'vue-i18n';
import { useEmployeeStore } from '@/stores/employee';

const { t } = useI18n();
const employeeStore = useEmployeeStore();
const $props = defineProps<{
  modelValue?: string;
  rootFormData?: any;
}>();
const $emit = defineEmits(['change', 'update:value', 'update:modelValue']);

const visible = ref(false);
const schemaForm$ref = ref();
const formData = ref<{
  password?: string;
  rePassword?: string;
}>({});
// Reset form data when dialog opens to prevent stale values
watch(visible, (val) => { if (val) formData.value = {}; });

const customRule = ({
  field,
  value,
  rootFormData,
  callback,
}: {
  field: string;
  value: any;
  rootFormData: any;
  callback: (error?: string) => void;
}) => {
  if (field === 'rePassword' && value !== rootFormData.password) return callback('passwords do not match');
  return callback();
};

const onSave = async () => {
  schemaForm$ref.value.formRef.$$uiFormRef.validate().then(async (valid: boolean) => {
    if (!valid) {
      return;
    }
    if (!formData.value.password) return;
    if ($props.rootFormData?.id_in_server) {
        formData.value.password = await employeeStore.changePassword(formData.value.password);
    }
    $emit('change', formData.value.password);
    $emit('update:value', formData.value.password);
    $emit('update:modelValue', formData.value.password);
    visible.value = false;
  }).catch(() => {});
};
</script>

<template>
  <div>
    <el-button type="primary" class="shrink-0 w-[50px]" @click="visible = true"
      ><el-icon size="20"><NewMessage /></el-icon
    ></el-button>
    <x-dialog
      v-model="visible"
      width="770px"
      :title="t('employee.editPassword')"
      :close-on-click-modal="false"
      :modal="false"
      :append-to-body="true"
    >
      <template #headerRight>
        <el-button @click="onSave" color="#80BA5C"
          ><el-icon size="20" color="#fff"><Done /></el-icon
        ></el-button>
      </template>
      <div class="w-full change-password">
        <SchemaForm :schema="passwordFormSchema" ref="schemaForm$ref" v-model="formData" :custom-rule="customRule" />
      </div>
    </x-dialog>
  </div>
</template>

<style lang="sass">
.change-password
  .el-form-item
    .el-input__suffix
      margin-left: 5px
</style>
